// ChatDefaultRenderer.jsx
import React from 'react';
import PropTypes from 'prop-types';

import UniversalContainer from '../component/UniversalContainer.jsx';

export const ChatDefaultRenderer = ({
  isOnDesktop = false,
  hasChatroom = false,
  isAuthed = false,
}) => {
  if (isOnDesktop) {
    if (hasChatroom && isAuthed) {
      return <UniversalContainer filename="DesktopChatDefault" />;
    } else {
      return (
        <UniversalContainer
          filename="GridDiscoverUsers"
          withChatLink
          size={104}
          marginTop={12}
        />
      );
    }
  } else {
    return <UniversalContainer filename="Chatrooms" />;
  }
};

ChatDefaultRenderer.propTypes = {
  hasChatroom: PropTypes.bool,
  isOnDesktop: PropTypes.bool,
  isAuthed: PropTypes.bool,
};

export default ChatDefaultRenderer;
